export function formatDate(timestamp) {
  return timestamp ? timestamp.toDate().toLocaleString() : "";
}
